<!--Carousel Starts-->
<section id="carousel">
  <div class="row  text-left">
    <div class="col-sm-12">
      <div class="content-header">Carousel</div>
      <p class="content-sub-header">Directive to easily create carousels based on Bootstrap's markup.</p>
    </div>
  </div>
  <div class="row  text-left">
    <!--Basic Carousel Starts-->
    <div class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Carousel</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ngb-carousel>
              <ng-template ngbSlide>
                <img src="assets/img/photos/12.jpg" alt="Random first slide">
                <div class="carousel-caption">
                  <h3 class="ff-serif text-uppercase">First slide label</h3>
                  <p class="mb-0">Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/photos/13.jpg" alt="Random second slide">
                <div class="carousel-caption">
                  <h3 class="ff-serif text-uppercase">Second slide label</h3>
                  <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/photos/14.jpg" alt="Random third slide">
                <div class="carousel-caption">
                  <h3 class="ff-serif text-uppercase">Third slide label</h3>
                  <p class="mb-0">Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
                </div>
              </ng-template>
            </ngb-carousel>
          </div>
        </div>
      </div>
    </div>
    <!--Basic Carousel Ends-->

    <!--Global configuration of carousels Starts-->
    <div class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Global configuration of carousels</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ngb-carousel>
              <ng-template ngbSlide>
                <img src="assets/img/photos/15.jpg" alt="Random first slide">
                <div class="carousel-caption">
                  <h3>10 seconds between slides...</h3>
                  <p>This carousel uses customized default values.</p>
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/photos/16.jpg" alt="Random second slide">
                <div class="carousel-caption">
                  <h3>No keyboard...</h3>
                  <p>This carousel uses customized default values.</p>
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/photos/17.jpg" alt="Random third slide">
                <div class="carousel-caption">
                  <h3>And no wrap after last slide.</h3>
                  <p>This carousel uses customized default values.</p>
                </div>
              </ng-template>
            </ngb-carousel>

          </div>
        </div>
      </div>
    </div>
    <!--Global configuration of carousels Starts-->

    <!-- <div class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Code</h4>
        </div>
        <div class="card-content">
          <div class="card-body">

            <pre class="language-typescript overflow-hidden text-left">
              <code class="language-typescript">
                import &#123;Component&#125; from '@angular/core';
                @Component(&#123;
                  selector: 'ngbd-carousel-basic',
                  templateUrl: './carousel-basic.html'
                &#125;)
                export class NgbdCarouselBasic &#123;
                &#125;</code>
          </pre>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Configuration Code</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <pre class="language-typescript text-left">
<code class="language-typescript">
  import &#123;Component&#125; from '@angular/core';
  import &#123;NgbCarouselConfig&#125; from '@ng-bootstrap/ng-bootstrap';

  @Component(&#123;
    selector: 'ngbd-carousel-config',
    templateUrl: './carousel-config.html',
    providers: [NgbCarouselConfig] // add NgbCarouselConfig to the component providers
  &#125;)
  export class NgbdCarouselConfig &#123;
    constructor(config: NgbCarouselConfig) &#123;

      config.interval = 10000;
      config.wrap = false;
      config.keyboard = false;
      config.pauseOnHover = false;
    &#125;
  &#125;</code>
            </pre>
          </div>
        </div>
      </div>
    </div> -->

  </div>
</section>
<!--Carousel Ends-->
